import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import FilterDrawer from './FilterDrawer';
import FilterIcon from '../Icons/Filter';
import breakpoints from '../Theme/breakpoints';
import useShowNavigation from '../lib/useShowNavigation';

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

const DrawerButtonWrapper = styled.div`
  display: inline-block;
  margin: 16px 0 24px;
  width: 50%;
  text-align: center;
  cursor: pointer;

  @media (min-width: ${breakpoints.md}px) {
    display: none;
  }
`;

const DrawerButtonText = styled.span`
  font-family: var(--font-secondary);
  font-size: 20px;
  text-transform: uppercase;
  line-height: 1em;
  display: inline-block;
  margin: 0 6px;
`;

const FilterWrapper = styled.div<{ showNavigation?: boolean }>`
  @media (min-width: ${breakpoints.md}px) {
    background-color: #f5f5f5;
    margin-left: 24px;
    min-width: 298px;
    width: 298px;
    position: sticky;
    height: 100vh;
    z-index: 1;
    transition: .5s ease-in-out;
    top: ${({ showNavigation }) => (showNavigation ? '106px' : '0')};
  }
`;

const ScrollContainer = styled.div`
  @media (min-width: ${breakpoints.md}px) {
    box-sizing: border-box;
    padding: 24px 16px 48px;

    @supports (position: sticky) {
      overflow: scroll;
      height: 100vh;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
`;

const Fade = styled.div`
  display: none;

  @media (min-width: ${breakpoints.md}px) {
    @supports (position: sticky) {
      display: inline;
      pointer-events: none;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 96px;
      background: linear-gradient(to bottom, rgba(245,245,245,0) 0%,
        rgba(245,245,245,1) 100%);
    }
  }
`;

const filterMenuPropertyTypes = {
  mainFilter: PropTypes.node.isRequired,
  resultsButton: PropTypes.node.isRequired,
  clearResults: PropTypes.func.isRequired,
  openDrawer: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  filtersActivated: PropTypes.bool.isRequired,
  filterDrawerOpen: PropTypes.bool.isRequired,
  filterMessage: PropTypes.string.isRequired,
  clearResultsMessage: PropTypes.string.isRequired,
};

type FilterMenuProperties = InferProps<typeof filterMenuPropertyTypes>;

const FilterMenu = ({
  resultsButton,
  mainFilter,
  children,
  filtersActivated,
  filterDrawerOpen,
  clearResults,
  openDrawer,
  filterMessage,
  clearResultsMessage,
}: FilterMenuProperties) => {
  const showNavigation = useShowNavigation();

  return (
    <FilterWrapper showNavigation={showNavigation}>
      <ScrollContainer>
        <div>
          { mainFilter }
        </div>
        <FlexContainer>
          <DrawerButtonWrapper
            onClick={openDrawer}
          >
            <FilterIcon />
            <DrawerButtonText>
              { filterMessage }
            </DrawerButtonText>
          </DrawerButtonWrapper>
        </FlexContainer>
        <FilterDrawer
          resultsButton={resultsButton}
          open={filterDrawerOpen}
          filtersActivated={filtersActivated}
          clearResults={clearResults}
          clearResultsMessage={clearResultsMessage}
        >
          { children }
        </FilterDrawer>
      </ScrollContainer>
      <Fade />
    </FilterWrapper>
  );
};

FilterMenu.propTypes = filterMenuPropertyTypes;

export default FilterMenu;
